import React from "react";
import { useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Styles/MotionMoarefi.css";

const MotionMoarefi = ({ slides }) => {
  const [motionMoarefiIndex, setMotionMoarefiIndex] = useState(0);
  const clickSlide = (i) => {
    setMotionMoarefiIndex(i);
  };
  return (
    <Swiper
      slidesPerView={1}
      navigation
      spaceBetween={10}
      centeredSlides={true}
      className={"MotionMoarefi_swiper-wrapper"}
      onSlideChange={(ex) => clickSlide(ex.activeIndex)}
      breakpoints={{
        1300: {
          slidesPerView: 1,
        },
        1200: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 1,
        },
      }}
    >
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/3bEi5/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionMoarefi_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/5iFYL/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionMoarefi_img"
        ></iframe>
      </SwiperSlide>
      {/* <SwiperSlide>
        <video className="MotionMoarefi_img" controls>
          <source
            src="/imgs/Landing/hisstoriInterviewMotion2.m4v"
            type="video/mp4"
          />
        </video>
      </SwiperSlide> */}
    </Swiper>
  );
};
MotionMoarefi.defaultProps = {};
export default MotionMoarefi;
